import React from "react";
import MinimizedChatPopUp from "../minimizedChatPopUp/minimizedChatPopUp";
import { AppContext } from "../../../../store/genesys.context";
import { useTeaserRevealed } from "../../../../store/teaserReveal.context";
import MinimizedChatBubble from "../../../atoms/minimizedChatBubble.styled";
import FA__MessageSmile from "../../../../assets/icons/message-smile-light-full.svg";
import SvgIcon from "../../../atoms/icons/svgIcon/svgIcon";

const MinimizedChat = ({
  ref,
}: {
  ref?: React.Ref<HTMLDivElement>;
}): React.JSX.Element => {
  const {
    showMinimizeBotPopup,
    handleMinimizeBot,
  }: {
    showMinimizeBotPopup: boolean;
    handleMinimizeBot: () => void;
  } = React.useContext(AppContext);
  const teaserRevealed = useTeaserRevealed();

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleMinimizeBot();
    }
  };

  return (
    <React.Fragment>
      {showMinimizeBotPopup && teaserRevealed && <MinimizedChatPopUp />}

      <MinimizedChatBubble
        ref={ref} // A11Y FIX: focus target when the chat window closes
        onClick={handleMinimizeBot}
        onKeyDown={handleKeyDown}
        role="button"
        tabIndex={0}
        aria-label="Chat öffnen"
      >
        <SvgIcon
          sizeInPx="32"
          icon={FA__MessageSmile}
          color={(theme) =>
            theme.palette.widgetStyles.minimizedChatBubble.iconColor
          }
        />
      </MinimizedChatBubble>
    </React.Fragment>
  );
};

export default MinimizedChat;
